import '../constants/colors.js';
import '../constants/fonts.js';
import '../constants/theme.js';
import '../constants/files.js';
import { DotSymbol } from '../constants/symbol.js';
import '../constants/color-variant.js';
import '../constants/zIndexList.js';

const camelCaseToSentenceCase = (camelCase) => {
    if (camelCase) {
        let result = camelCase // "__ToGetYourGEDInTimeASongAboutThe26ABCsIsOfTheEssenceButAPersonalIDCardForUser_456InRoom26AContainingABC26TimesIsNotAsEasyAs123ForC3POOrR2D2Or2R2D"
            .replace(/(_)+/g, " ") // " ToGetYourGEDInTimeASongAboutThe26ABCsIsOfTheEssenceButAPersonalIDCardForUser 456InRoom26AContainingABC26TimesIsNotAsEasyAs123ForC3POOrR2D2Or2R2D"
            .replace(/([a-z])([A-Z][a-z])/g, "$1 $2") // " To Get YourGEDIn TimeASong About The26ABCs IsOf The Essence ButAPersonalIDCard For User456In Room26AContainingABC26Times IsNot AsEasy As123ForC3POOrR2D2Or2R2D"
            .replace(/([A-Z][a-z])([A-Z])/g, "$1 $2") // " To Get YourGEDIn TimeASong About The26ABCs Is Of The Essence ButAPersonalIDCard For User456In Room26AContainingABC26Times Is Not As Easy As123ForC3POOr R2D2Or2R2D"
            .replace(/([a-z])([A-Z]+[a-z])/g, "$1 $2") // " To Get Your GEDIn Time ASong About The26ABCs Is Of The Essence But APersonal IDCard For User456In Room26AContainingABC26Times Is Not As Easy As123ForC3POOr R2D2Or2R2D"
            .replace(/([A-Z]+)([A-Z][a-z][a-z])/g, "$1 $2") // " To Get Your GEDIn Time A Song About The26ABCs Is Of The Essence But A Personal ID Card For User456In Room26A ContainingABC26Times Is Not As Easy As123ForC3POOr R2D2Or2R2D"
            .replace(/([a-z]+)([A-Z0-9]+)/g, "$1 $2") // " To Get Your GEDIn Time A Song About The 26ABCs Is Of The Essence But A Personal ID Card For User 456In Room 26A Containing ABC26Times Is Not As Easy As 123For C3POOr R2D2Or 2R2D"
            // Note: the next regex includes a special case to exclude plurals of acronyms, e.g. "ABCs"
            .replace(/([A-Z]+)([A-Z][a-rt-z][a-z]*)/g, "$1 $2") // " To Get Your GED In Time A Song About The 26ABCs Is Of The Essence But A Personal ID Card For User 456In Room 26A Containing ABC26Times Is Not As Easy As 123For C3PO Or R2D2Or 2R2D"
            .replace(/([0-9])([A-Z][a-z]+)/g, "$1 $2") // " To Get Your GED In Time A Song About The 26ABCs Is Of The Essence But A Personal ID Card For User 456In Room 26A Containing ABC 26Times Is Not As Easy As 123For C3PO Or R2D2Or 2R2D"
            // Note: the next two regexes use {2,} instead of + to add space on phrases like Room26A and 26ABCs but not on phrases like R2D2 and C3PO"
            .replace(/([A-Z]{2,})([0-9]{2,})/g, "$1 $2") // " To Get Your GED In Time A Song About The 26ABCs Is Of The Essence But A Personal ID Card For User 456 In Room 26A Containing ABC 26 Times Is Not As Easy As 123 For C3PO Or R2D2 Or 2R2D"
            .replace(/([0-9]{2,})([A-Z]{2,})/g, "$1 $2") // " To Get Your GED In Time A Song About The 26 ABCs Is Of The Essence But A Personal ID Card For User 456 In Room 26A Containing ABC 26 Times Is Not As Easy As 123 For C3PO Or R2D2 Or 2R2D"
            .trim(); // "To Get Your GED In Time A Song About The 26 ABCs Is Of The Essence But A Personal ID Card For User 456 In Room 26A Containing ABC 26 Times Is Not As Easy As 123 For C3PO Or R2D2 Or 2R2D"
        // capitalize the first letter
        return result.charAt(0).toUpperCase() + result.slice(1);
    }
    return "";
};
const removeNonAlphaNumeric = (str = "") => {
    return str.replace(/[^a-z0-9]/gi, "");
};
const removeNonNumeric = (str = "") => {
    return str.replace(/[^0-9]/g, "");
};
const extractDigits = (str = "") => str.replace(/\D+/g, "");
function compareString(str1, str2) {
    return (str1 === null || str1 === void 0 ? void 0 : str1.toLowerCase()) === (str2 === null || str2 === void 0 ? void 0 : str2.toLocaleLowerCase());
}
const stringOperations = (inputString, operations) => {
    let result = inputString !== null && inputString !== void 0 ? inputString : "";
    if (operations.includes("trim")) {
        result = result.trim();
    }
    if (operations.includes("toUpperCase")) {
        result = result.toUpperCase();
    }
    if (operations.includes("toLowerCase")) {
        result = result.toLowerCase();
    }
    if (operations.includes("replaceWhitespace")) {
        result = result.replace(/\s+/g, "");
    }
    if (operations.includes("replaceSpacesWithUnderscore")) {
        result = result.replace(/\s+/g, "_");
    }
    if (operations.includes("replaceUnderscoreWithSpace")) {
        result = result.replace(/_+/g, " ");
    }
    if (operations.includes("capitalizeEachWord")) {
        result = result
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" ");
    }
    if (operations.includes("removeNonAlphaNumeric")) {
        result = result.replace(/[^a-zA-Z0-9\s]/g, "");
    }
    if (operations.includes("removeNonNumeric")) {
        result = result.replace(/[^0-9]/g, "");
    }
    if (operations.includes("removeLeadingZero")) {
        result = result.replace(/^0+/, "");
    }
    if (operations.includes("removeSpecialCharacters")) {
        result = result.replace(/[^a-zA-Z ]/g, "");
    }
    const truncateOperation = operations.find((op) => op.startsWith("truncate:"));
    if (truncateOperation) {
        const maxLength = parseInt(truncateOperation.split(":")[1], 10);
        result =
            result.length > maxLength ? result.slice(0, maxLength) : result;
    }
    return result;
};
const getDotSeparatedStringFromStringArray = (arr) => {
    return arr.filter((v) => !!v).join(` ${DotSymbol} `);
};
const extractPhoneNumber = (input = "") => {
    if (typeof input === "string") {
        let digits = input.replace(/\D/g, ""); // Remove non-digits
        if (digits.length > 10) {
            digits = digits.slice(-10);
        }
        digits = digits.replace(/^0+/, ""); // Remove leading zeros
        if (digits.length === 10) {
            return digits;
        }
    }
    return "";
};
const formattedPhoneNumber = (input = "", format = "+91-") => {
    const result = extractPhoneNumber(input);
    return result ? format + result : "";
};

export { camelCaseToSentenceCase, compareString, extractDigits, extractPhoneNumber, formattedPhoneNumber, getDotSeparatedStringFromStringArray, removeNonAlphaNumeric, removeNonNumeric, stringOperations };
//# sourceMappingURL=string.js.map
